import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { RevenuePlanApi } from '../revenuePlan.api';

export const useGetCalculationsOnProductUpdateRevenue = () => {
  return useMutation({
    mutationKey: CALCULATIONS_MUTATION_KEY,
    mutationFn: RevenuePlanApi.getCalculationsOnProductUpdate,
  });
};
